export enum AuditType {
  RefundError = 'refundError',
  LockOpen = 'lockOpen',
  ReservationStatusChange = 'reservationStatusChange',
  RoomStatusChange = 'roomStatusChange',
}
